import PropTypes from 'prop-types';

import { ReactComponent as ArrowSingle } from '../../../../resources/icons/arrow-single.svg';
import { ReactComponent as ArrowDouble } from '../../../../resources/icons/arrow-double.svg';

import './page-buttons.scss';

const PageButtons = ({ currentPage, totalPages, onPageChange }) => {
  const goToFirstPage = () => {
    if (currentPage > 0) {
      onPageChange(0);
    }
  };

  const decrementPage = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const incrementPage = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const goToLastPage = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(totalPages - 1);
    }
  };

  return (
    <section className="page-buttons">
      <button className="page-buttons__button" onClick={goToFirstPage} data-testid="first-page-button">
        <ArrowDouble fill="white" />
      </button>
      <button className="page-buttons__button" onClick={decrementPage} data-testid="previous-page-button">
        <ArrowSingle fill="white" />
      </button>
      {totalPages > 0 && <div className="page-buttons__page-number">{`${currentPage + 1} of ${totalPages}`}</div>}
      {totalPages < 1 && <div className="page-buttons__page-number">0 of 0</div>}
      <button className="page-buttons__button" onClick={incrementPage} data-testid="next-page-button">
        <ArrowSingle fill="white" />
      </button>
      <button className="page-buttons__button" onClick={goToLastPage} data-testid="last-page-button">
        <ArrowDouble fill="white" />
      </button>
    </section>
  );
};

PageButtons.propTypes = {
  totalPages: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default PageButtons;
